import request from '../util/request'

export function getEvaluationRuleTree(params) {
  return request({
    url: 'pr/evaluation-rules/_tree',
    method: 'get',
    params
  })
}

export function deleteEvaluationRule(id) {
  return request({
    url: `pr/evaluation-rules/${id}`,
    method: 'delete'
  })
}

/**
 * 创建评价表
 * @param {*} data 
 * @returns 
 */
export function createEvaluationRule(data) {
  return request({
    url: 'pr/evaluation-rules',
    method: 'post',
    data
  })
}

/**
 * 更新评价表
 * @param {*} id 
 * @param {*} data 
 * @returns 
 */
export function updateEvaluationRule(id, data) {
  return request({
    url: `pr/evaluation-rules/${id}`,
    method: 'put',
    data
  })
}

/**
 * 重新排序
 * @param {*} id 
 * @param {*} data 
 * @returns 
 */
export function reorderEvaluationRule(id, data) {
  return request({
    url: `pr/evaluation-rules/${id}/_reorder`,
    method: 'put',
    data
  })
}